export const SELECTABLE_CATEGORIES = {
  bolt: 'bolt',
  plenty: 'plenty'
} as const
export type SelectableCategory = (typeof SELECTABLE_CATEGORIES)[keyof typeof SELECTABLE_CATEGORIES]
